// extracted by mini-css-extract-plugin
module.exports = {"content":"HoverText_content__TfP61","contentPopover":"HoverText_contentPopover__Y5mLh"};